import axios from 'axios';
import { AuthUtils } from 'guards/auth.guard';
// ----------------------------------------------------------------------

/* ----------------------------------------------------------------------------
   BASE DA API.

   Em PRODUCAO e o dominio da API (`HOST_API_KEY`, injetado pelo vite.config).

   Em DESENVOLVIMENTO e a ORIGEM DA PAGINA. Isto e o que faz o acesso pela rede
   funcionar: o valor injetado em dev era a string fixa `http://localhost:3000`,
   entao ao abrir o front por http://10.134.0.60:3000 o navegador continuava
   pedindo a API em `localhost:3000` - ou seja, na MAQUINA DE QUEM ACESSA, nao na
   que roda o servidor. De outro computador ou do celular, nada respondia; da
   maquina do desenvolvedor funcionava por coincidencia.

   Usar `window.location.origin` resolve porque o proxy do Vite responde na mesma
   origem que serviu a pagina, qualquer que seja o endereco usado para chegar
   nela - localhost, IP da rede ou nome da maquina.

   O fallback continua sendo `HOST_API_KEY`: fora do navegador (algum script, um
   teste) nao existe `window`.
   ---------------------------------------------------------------------------- */
const ehDesenvolvimento = process.env.NODE_ENV !== 'production';
const baseAPI =
  ehDesenvolvimento && typeof window !== 'undefined'
    ? window.location.origin
    : process.env.HOST_API_KEY || '';

const axiosInstance = axios.create({ baseURL: baseAPI });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    // Log so em desenvolvimento. Antes era `console.log('ERROR PRINCIPAL: ', error)`
    // em toda falha, inclusive em producao, despejando objeto de erro completo
    // (com headers e corpo da requisicao) no console do navegador do usuario.
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[api] ${status ?? 'sem status'} ${error?.config?.method?.toUpperCase() ?? ''} ${error?.config?.url ?? ''}`);
    }

    // ------------------------------------------------------------------------
    // CORRIGIDO: antes 401 **e 403** apagavam o token e chamavam
    // window.location.reload().
    //
    // O problema: 403 nao significa "sessao invalida" - significa "autenticado,
    // mas sem permissao para ESTE recurso". Como o dashboard dispara varias
    // chamadas em paralelo, uma unica delas negada por perfil derrubava a sessao
    // inteira e o usuario voltava para a tela de login logo apos entrar. Era
    // indistinguivel de "login nao funciona".
    //
    // Agora:
    //   401 -> sessao realmente invalida: limpa e manda para o login.
    //   403 -> propaga o erro para a tela tratar (ex.: "sem permissao"), SEM
    //          derrubar a sessao.
    //
    // Tambem trocamos reload() por redirect com guarda: reload em pagina que
    // dispara a chamada negada pode entrar em laco de recarregamento.
    // ------------------------------------------------------------------------
    if (status === 401) {
      window?.localStorage?.removeItem('gpshub:accessToken');
      window?.localStorage?.removeItem('gpshub:user');

      const caminhoAtual = window?.location?.pathname ?? '';
      if (!caminhoAtual.startsWith('/auth/')) {
        window.location.assign('/auth/login');
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
